<div>
    <div class="header">
        <h1>
            {{title}}
        </h1>
    </div>

    <div class="like-count">
        <kin-icon (iconClick)="likeIconClick()" class="icon" [name]="( liked | async) ? 'like_fill' : 'like_outline'"
            [color]=" ( liked | async) ? '#ffc947' : '#7e8184'" />
        <p class="count">{{likeCount | async}}</p>
        <span> {{ "watch.content.counter.likes_count" | translate | lowercase}} </span>
    </div>

    <!-- User Skeleton -->
    @if(loading$ | async){
    <div class="skeletonWrapper">
        <div class="user-skeleton" *ngFor="let sk of [0,0,0,0,0,0,0,0,0,0]">
            <div class="start">
                <p-skeleton shape="circle" height="4rem" width="4rem"></p-skeleton>
                <p-skeleton height="1.5rem" width="5rem"></p-skeleton>
            </div>
            <p-skeleton height="3rem" width="11.25rem" borderRadius="0.7rem"></p-skeleton>
        </div>
    </div>
    }

    @if(userLikes.getValue().length > 0){
    <div class="content" infiniteScroll [infiniteScrollDistance]="1.1" [infiniteScrollThrottle]="70"
        [infiniteScrollDisabled]="loading$ | async" [fromRoot]="true"
        [infiniteScrollContainer]="scrollContainerSelector" (scrolled)="onScrollBottom()">


        @for (like of userLikes | async; track $index) {
        <div class="like">
            <div class="like-left">
                <img class="user-avatar" [src]="like.avatar_url" alt="user's avatar">
                <span class="user-name">{{like.username}}</span>
            </div>


            <div class="status-cont" *ngIf="like.id !== currentUser.id">
                <ng-container *ngIf="!getFollowStatus(like.id); else notFollowed">
                    <button class="btn-primary btn-icon" (click)="followUser(like.id)" *ngIf=" xSmallScreen"><span
                            class="icon icon-like"></span></button>
                    <button class="btn-primary" (click)="followUser(like.id)" *ngIf=" !xSmallScreen">Suivre</button>
                </ng-container>
                <ng-template #notFollowed>
                    <p class="followed">Abonné(e)</p>
                </ng-template>
            </div>

        </div>
        }
    </div>
    }

    @if((likeCount| async) === 0){
    <div class="like-placeholder">{{ 'watch.comments.empty' | translate }}</div>
    }
</div>